import { render, staticRenderFns } from "./VehiclesHistory.vue?vue&type=template&id=a0bfee86&scoped=true"
import script from "./VehiclesHistory.vue?vue&type=script&lang=js"
export * from "./VehiclesHistory.vue?vue&type=script&lang=js"
import style0 from "./VehiclesHistory.vue?vue&type=style&index=0&id=a0bfee86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bfee86",
  null
  
)

export default component.exports